export class DecodedLogParam {
  name?: string;

  type: string;

  indexed: boolean;

  decoded: boolean;

  value: any;
}
